/* Lirogo — selector real de columnas para colecciones Shopify.
   Desktop: 2 / 4 / 6; móvil: 1 / 2 / 3.
   Escribe directamente sobre la grilla del tema, incluso si el CSS usa !important. */
(function () {
  'use strict';
  var selections = new Map();

  function sectionFor(button) {
    return button.closest('collection-component') || button.closest('[data-section-type="collection"]');
  }

  function apply(section, device, count) {
    if (device === 'desktop' && [2, 4, 6].indexOf(count) === -1) return;
    if (device === 'mobile' && [1, 2, 3].indexOf(count) === -1) return;

    var key = section.id || section.dataset.sectionId;
    if (key) {
      var previous = selections.get(key) || {};
      previous[device] = count;
      selections.set(key, previous);
    }
    section.style.setProperty('--lirogo-columns-' + device, String(count));
    section.dataset[device === 'desktop' ? 'lirogoSelectedDesktop' : 'lirogoSelectedMobile'] = String(count);
    if (device === 'mobile') section.dataset.lirogoMobileColumns = String(count);

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var activeDevice = isMobile ? 'mobile' : 'desktop';
    var activeCount = Number(section.dataset[activeDevice === 'mobile' ? 'lirogoSelectedMobile' : 'lirogoSelectedDesktop']);
    if (!activeCount) {
      activeCount = parseInt(getComputedStyle(section).getPropertyValue('--lirogo-columns-' + activeDevice), 10);
    }

    var grid = section.querySelector('[data-products-grid] > .grid');
    if (grid && activeCount > 0) {
      /* Importante: el tema tiene reglas !important para la grilla Mango.
         El estilo inline normal NO las sobreescribe; el inline important sí. */
      grid.style.setProperty('--columns', String(activeCount), 'important');
      grid.style.setProperty('grid-template-columns', 'repeat(' + activeCount + ', minmax(0, 1fr))', 'important');
      section.style.setProperty(isMobile ? '--COLUMNS-MOBILE' : '--COLUMNS', String(activeCount));
      section.classList.toggle('lirogo-grid-custom-columns', !isMobile && activeCount !== 4);
    }

    section.querySelectorAll('[data-lirogo-grid-device="' + device + '"][data-lirogo-grid-count]').forEach(function (button) {
      var selected = Number(button.dataset.lirogoGridCount) === count;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  }

  /* Captura el clic antes de que un componente del tema pueda interceptarlo. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lirogo-grid-device][data-lirogo-grid-count]');
    if (!button) return;
    var section = sectionFor(button);
    if (!section) return;
    event.preventDefault();
    apply(section, button.dataset.lirogoGridDevice, Number(button.dataset.lirogoGridCount));
  }, true);

  function restore(root) {
    var sections = [];
    if (root.matches && root.matches('collection-component')) sections.push(root);
    if (root.querySelectorAll) root.querySelectorAll('collection-component').forEach(function (s) { sections.push(s); });
    sections.forEach(function (section) {
      var key = section.id || section.dataset.sectionId;
      var saved = key && selections.get(key);
      if (!saved) return;
      if (saved.desktop) apply(section, 'desktop', saved.desktop);
      if (saved.mobile) apply(section, 'mobile', saved.mobile);
    });
  }

  document.addEventListener('shopify:section:load', function (event) { restore(event.target); });
  document.addEventListener('DOMContentLoaded', function () {
    restore(document);
    document.querySelectorAll('collection-component.collection--mango-mixed-grid').forEach(function (section) {
      var count = Number(section.dataset.lirogoSelectedDesktop) || parseInt(getComputedStyle(section).getPropertyValue('--lirogo-columns-desktop'), 10);
      section.classList.toggle('lirogo-grid-custom-columns', count !== 4);
    });
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('collection-component[data-lirogo-desktop-selector]').forEach(function (section) {
      var device = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
      var count = Number(section.dataset[device === 'mobile' ? 'lirogoSelectedMobile' : 'lirogoSelectedDesktop']);
      if (count) apply(section, device, count);
      else {
        if (device === 'desktop') {
          var initial = parseInt(getComputedStyle(section).getPropertyValue('--lirogo-columns-desktop'), 10);
          section.classList.toggle('lirogo-grid-custom-columns', initial !== 4);
        }
        var grid = section.querySelector('[data-products-grid] > .grid');
        if (grid) {
          grid.style.removeProperty('--columns');
          grid.style.removeProperty('grid-template-columns');
        }
      }
    });
  });
})();
